export enum PricingProfilePartNumberType {
  PRICE = 'price',
  MARGIN = 'margin',
}
